import { createContext } from 'react';

export type SelectedSite = {
  id?: string | undefined;
  origin: 'list' | 'map' | 'overview';
  overviewSelected: boolean;
};

export type SearchLimit = {
  exceeded: boolean;
  count: number;
};

type SiteLookupMapContextProps = {
  isMapExtended: boolean;
  toggleIsMapExtended: () => void;
  setIsMapExtended: (value: boolean) => void;
  selectedSite: SelectedSite | null;
  setSelectedSite: (value: SelectedSite | null) => void;
  searchLimit: SearchLimit | null;
  setSearchLimit: (value: SearchLimit | null) => void;
  hasSitesIncludedInReport: boolean;
  setHasSitesIncludedInReport: (value: boolean) => void;
};

const SiteLookupMapContext = createContext<SiteLookupMapContextProps>({
  isMapExtended: false,
  toggleIsMapExtended: () => {},
  setIsMapExtended: () => {},
  selectedSite: null,
  setSelectedSite: () => {},
  searchLimit: null,
  setSearchLimit: () => {},
  hasSitesIncludedInReport: true,
  setHasSitesIncludedInReport: () => {},
});

export default SiteLookupMapContext;
